export const BrandAlignItems = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const
export type BrandAlignItems =
  (typeof BrandAlignItems)[keyof typeof BrandAlignItems]
